import BrainAssistantAPI from 'dashboard/api/brain/assistant';
import { createStore } from '../storeFactory';

export default createStore({
  name: 'BrainAssistant',
  API: BrainAssistantAPI,
});
